import React, { useState } from "react";

export const ProductTabContext = React.createContext({});
export const ProductTabContextProvider = ({ children }) => {
    const [ProductTab, setProductTab] = useState({ tab: "ProductList", id: 0 });
  
    return (
        <ProductTabContext.Provider value={{ ProductTab, setProductTab }}>
            {children}
        </ProductTabContext.Provider>
    );
};
